import { render, staticRenderFns } from "./IBANinput.vue?vue&type=template&id=8658c1b8"
import script from "./IBANinput.vue?vue&type=script&lang=js"
export * from "./IBANinput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports